module.exports = __webpack_public_path__ + "media/images/icon_money_25_25-935e1f7c2e4dcc71bb5d1a391cb15f7c.png";